export default {
  props: {
    items: {
      type: Array,
    },
  },

  data() {
    return {
      selected: 0,
    }
  },

  methods: {
    selectItem(index) {
      this.selected = index
    },
  },
}
